import React from 'react';
import { Button } from 'antd';
import logoIcon from 'assets/img/login-elsa-logo-icon.svg';
import logoWordmark from 'assets/img/login-elsa-logo-wordmark.svg';
import './forgetPassword.css';
import { useTranslation } from 'react-i18next';
import GlobalStore from 'stores/globalStore';
import { Helmet } from 'react-helmet';
import { getUniversalResetPasswordUrl } from 'utils/universal-login';

const ForgetPassword: React.FC = () => {
  const { t } = useTranslation();
  const { currentLanguage } = GlobalStore.useContainer();

  return (
    <div className="signin-container">
      {currentLanguage === 'ja' ? (<Helmet>
        <title>パスワードをお忘れの方 - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak アカウントのパスワードを再設定します。ご登録のメールアドレスに、パスワード変更用のリンクをお送りします。"
        />
      </Helmet>) :
      <Helmet>
        <title>Forget Password - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App forget password on web PC. Redeem promo code ELSA Pro, Oxford Business Result, ELSA for Students, ELSA Speak free."
        />
      </Helmet>}
      <div className="logo">
        <div className="logo-mark">
          <img className="logo-mark-icon" alt="logo" src={logoIcon} />
          <img className="logo-mark-wordmark" alt="" src={logoWordmark} />
        </div>
      </div>
      <div className="form-container form-forget">
        <h1>{t('reset.forgot_password')}</h1>
        <Button
          className="submit-button"
          onClick={() => {
            window.location.href = getUniversalResetPasswordUrl();
          }}
        >
          {t('reset.send_require')}
        </Button>
      </div>
    </div>
  );
};

export default ForgetPassword;
